<script>
  import { push } from "svelte-spa-router"
  import { onDestroy, onMount, tick } from "svelte"
  import notify from "../../../../../Script/notify"
  import { loadJs } from "../../../../../Script/loadLibrary"
  import { postRequest, patchRequest, getRequest } from "../../../../../Script/apiMethods"
  import { modifyPlacement, checkOutOfBoundary } from "./Script/placement"

  import { EMAIL_REGEX } from "./Script/utils"

  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import Button from "../../../../../Shared/button.svelte"
  import Uploadfile from "../../../../../Shared/uploadfile.svelte"

  import { loadFile, parsePdf } from "./Script/loadFile"
  import { drawSign } from "../../../SingleDocket/Script/sign"

  import Approver from "./Components/approver.svelte"
  import SignerList from "./Components/signerList.svelte"
  import Modal from "./Components/modal.svelte"
  import Loader from "./Components/loader.svelte"
  import Header from "./Components/header.svelte"

  import SignOverlay from "./Modules/SignOverlay/index.svelte"

  import PageControl from "../../../SingleDocket/Components/pageControl.svelte"

  import ApplicationState from "../../../../../Stores/applicationStates"

  import PdfPreview from "../../../../../UniqueComponents/pdfPreview.svelte"
  import Footer from "../../../../../Shared/footer.svelte"
  import DocDetails from "./Stores/document"

  let files = null

  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  let closeNotification = {
    close() {},
  }

  /**
   * @typedef {Object} invalidNotification
   * @property {Function} close - Closes the notification.
   */
  let invalidNotification = {
    close() {},
  }

  /**
   * @typedef {Object} maxNotification
   * @property {Function} close - Closes the notification.
   */
  let maxNotification = {
    close() {},
  }

  let canvas

  let loadingPDF = false

  let currentpage = 1
  /**
   * @type {Number} - while changing pages number simultaneously that pages number stored as pending page number
   */
  let pageNumPending = null

  let totalPages

  /**
   * @type {Object} - store the pdf details
   */
  let _PDFDOC

  /**
   * @type {Array<import("../../Script/types").User>}
   */
  let users = []

  let pdfDimensions = {}

  let showLoader = false

  let loaderMsg = "Fetching Details"

  let isPublishEnabled = true

  let showEmailConfirmationModal = false

  let showGoBackModal = false

  let action = "Approvers"
  // let action = "Signers"

  /**
   * @type {Boolean} - whether to show or not user delete model
   */
  let showUserDltModal = false

  /**
   * @type {String} - active tab ID
   */
  let activeId = ""

  /**
   * @type {String} - active tab name
   */
  let activeName = ""
  /**
   * @type {Boolean} - whether to show or note add sigenr section
   */
  let addSignerSection = false //my changes

  let pdfDigitallySignedModal = false

  let docketName = ""
  let docketOrgEmail = ""
  let emailAddressPattern = /^[A-Z0-9.!#$%&'+/=?^_`{|}~-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+){1,}$/i

  let isPdfDigitallySigned = false

  let pdfHasDifferentSize = false

  let sealCount = 0
  let seals = []
  let sealEndCount = 0
  let sealMaxCount = 0

  let pageDimensions = []

  onMount(async () => {
    // Prevent execution if unauthorized (because pop() is asynchronous)
    if (!$ApplicationState.pdfEnabled || !$ApplicationState.msignToken) return

    try {
      showLoader = true
      loaderMsg = "Fetching Document Details..."

      console.log("onMount")

      await fetchSeals()

      if ($DocDetails.id && $DocDetails.url) {
        files = $DocDetails.file
        isPdfDigitallySigned = $DocDetails.isPdfDigitallySigned

        // For Collection of Page Dimensions

        let blobURL = URL.createObjectURL(files)
        await collectDimensionsPDF(blobURL)
        URL.revokeObjectURL(blobURL)

        await showSignOverlay(false)
      }
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: onMount"
      closeNotification = notify.danger(error, info)
    } finally {
      loaderMsg = "Fetching Details"
      showLoader = false
    }
  })

  const collectDimensionsPDF = async (url) => {
    // Load the pdf.js library if it's not already loaded
    await loadJs("pdfjsLib", "assets/lib/pdf.js")

    // Load the pdf.js worker if it's not already loaded
    await loadJs("pdfjsWorker", "assets/lib/pdf.worker.js")

    // Specify the workerSrc property for pdf.js
    pdfjsLib.GlobalWorkerOptions.workerSrc = "assets/lib/pdf.worker.js"

    // Start downloading the PDF asynchronously
    let loadingTask = pdfjsLib.getDocument(url)

    // Await the completion of the PDF loading task
    loadingTask = loadingTask.promise
    _PDFDOC = await loadingTask

    totalPages = _PDFDOC.numPages

    pageDimensions = []

    for (let i = 0; i < totalPages; i++) {
      const page = await _PDFDOC.getPage(i + 1)
      const { width, height } = page.getViewport({ scale: 1 })

      pageDimensions.push(`${width}*${height}`)
    }
  }

  const checkFileUpload = async (e) => {
    if (!e.target.files) return
    try {
      users = []

      const MAX_FILE_SIZE = 2 * 1024 * 1024

      if (e.target.files[0].size > MAX_FILE_SIZE) throw "Maximum File size exceeded"

      showLoader = true

      loaderMsg = "Validating File..."

      let { file, type } = await loadFile(e.target.files[0])

      isPdfDigitallySigned = await parsePdf(file)

      if (type == "docx") {
        loaderMsg = "Please wait, Converting to PDF..."
        file = await convertToPdf(file)
      }

      files = file
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: While validating uploaded document before proceeding with docket creation"
      closeNotification = notify.danger(error, info)
      e.target.value = ""
      files = null
    } finally {
      loaderMsg = "Fetching Details"
      loadingPDF = false
      showLoader = false
    }
  }

  const convertToPdf = async (file) => {
    try {
      const REQ_URL = `/api/doc/convert`
      const REQ_BODY = {
        file: file,
      }
      const CONFIG = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "blob",
      }

      const data = await postRequest(REQ_URL, REQ_BODY, CONFIG)

      let fileName = file.name.split(".")[0]

      let convertedFile = new File([data], `${fileName}.pdf`, {
        type: "application/pdf",
      })

      return convertedFile
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  /**
   * Loads and displays a PDF from the given URL using pdf.js.
   *
   * @param {string} url - The URL of the PDF to display.
   * @returns {Promise<void>} - A promise that resolves when the PDF is successfully loaded and displayed.
   */
  const showPDF = async (url) => {
    try {
      // Set the loading flag to true to indicate that the PDF is loading
      loadingPDF = true

      // Load the pdf.js library if it's not already loaded
      await loadJs("pdfjsLib", "assets/lib/pdf.js")

      // Load the pdf.js worker if it's not already loaded
      await loadJs("pdfjsWorker", "assets/lib/pdf.worker.js")

      // Specify the workerSrc property for pdf.js
      pdfjsLib.GlobalWorkerOptions.workerSrc = "assets/lib/pdf.worker.js"

      // Start downloading the PDF asynchronously
      let loadingTask = pdfjsLib.getDocument(url)

      // Await the completion of the PDF loading task
      _PDFDOC = await loadingTask.promise

      // Get the total number of pages in the PDF document
      totalPages = _PDFDOC.numPages

      // Display the current page of the PDF
      await showPage(currentpage)
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  /**
   * Renders a specific page of the loaded PDF document onto a canvas.
   *
   * @param {number} pageno - The page number to display.
   * @returns {Promise<void>} - A promise that resolves when the page is successfully rendered.
   */
  const showPage = async (pageno) => {
    try {
      pageno = Number(pageno)

      // Set the loading flag to true to indicate that a PDF page is being loaded
      loadingPDF = true

      // Get the specified page from the PDF document
      let page = await _PDFDOC.getPage(pageno)

      // Get the viewport for the page at a scale of 1
      let viewport = page.getViewport({ scale: 1 })

      // Prepare the canvas using the PDF page dimensions
      let context = canvas.getContext("2d")
      pdfDimensions.width = canvas.width = viewport.width
      pdfDimensions.height = canvas.height = viewport.height

      // pdfDimensions.clientWidth = canvas.clientWidth
      // pdfDimensions.clientHeight = canvas.clientHeight

      pdfDimensions.clientWidth = parseFloat(getComputedStyle(canvas).width)
      pdfDimensions.clientHeight = parseFloat(getComputedStyle(canvas).height)

      // console.log({ pdfDimensions })

      // Create the render context with canvas context and viewport
      let renderContext = {
        canvasContext: context,
        viewport: viewport,
      }

      // Render the PDF page into the canvas context
      await page.render(renderContext).promise

      // Set the loading flag to false to indicate that the PDF page has finished loading
      loadingPDF = false

      // Check if a new page rendering is pending
      if (pageNumPending !== null) {
        // Render the pending page and reset the pending page number
        showPage(pageNumPending)
        pageNumPending = null
      }
    } catch (error) {
      // Set the loading flag to true in case of an error (could be false as well to stop loading indicator)
      loadingPDF = true
      // Log the error (commented out)
      console.error(error)
      throw error
    }
  }

  const validateDuplicates = (role) => {
    try {
      let entries = users.filter((user) => user.role == role.toLowerCase())
      const userMap = new Map()

      for (let i = 0; i < entries.length; i++) {
        if (userMap.has(entries[i].email)) {
          entries[i].error = entries[i + 1].error = true
          throw `${role} named as ${entries[i].name} and ${role} ${entries[i + 1].name} are the same. Duplicates not allowed.`
          // const duplicateIndex = userMap.get(entries[i].email) + 1
          // throw `${role} ${duplicateIndex} and ${role} ${i + 1} are the same. Duplicates not allowed.`
        }
        userMap.set(entries[i].email, i)
      }
    } catch (error) {
      throw error
    }
  }

  // const validateLastEntry = (role) => {
  //   try {
  //     let filteredUser = users.filter((user) => user.role == role) || []
  //     let position = filteredUser.length
  //     if (position != 0) {
  //       let lastEntry = filteredUser[position - 1]
  //       if (!lastEntry.email.trim()) throw `${role} ${position} email shouldn't be empty.`
  //       if (!EMAIL_REGEX.test(lastEntry.email)) throw `Kindly provide valid email address for ${role} ${position}.`
  //       if (!lastEntry.hasOwnProperty("internal")) throw `Kindly check / submit email address to fetch details for ${role} ${position}`
  //       if (!lastEntry.name.trim()) throw `${role} ${position} name shouldn't be empty.`

  //       if (role == "SIGNER") if (!Boolean(filteredUser[position - 1].placements.length)) throw `Kindly add atleast one signature placement for Signer ${position}`
  //     }

  //     if (position > 1) validateDuplicates(role)
  //   } catch (error) {
  //     throw error
  //   }
  // }

  const addUser = async (role) => {
    try {
      validateAllEntries(role)
      users = users.map((user) => {
        user.active = false
        return user
      })
      users = [...users, { id: Date.now(), role: role, name: "", email: "", designation: "", placements: [], active: true }]
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = `PAGE: Docket Creation\nEVENT: While adding ${role}`
      closeNotification = notify.danger(error, info)
    }
  }

  const createDocket = async (refId, file, url) => {
    try {
      const REQ_URL = "/api/pdf-signing/v2/docket"

      const REQ_BODY = {
        file,
        name: docketName,
        orgEmail: docketOrgEmail ? docketOrgEmail : $ApplicationState.email,
      }
      if (refId) {
        REQ_BODY.documentID = refId
        REQ_BODY.url = url
        REQ_BODY.token = "Multi-Signing-Token"
      }

      const CONFIG = {
        headers: {
          "Content-Type": "multipart/form-data",
          "msign-org-token": $ApplicationState.msignToken,
        },
      }
      const { docket } = await postRequest(REQ_URL, REQ_BODY, CONFIG)

      return docket.id
    } catch (error) {
      throw error
    }
  }

  const initDocument = async () => {
    try {
      const REQ_URL = "/api/swagger/v2/documents"
      const REQ_BODY = { filename: "multi-signing" }
      const CONFIG = {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }
      const data = await postRequest(REQ_URL, REQ_BODY, CONFIG)

      return data
    } catch (error) {
      throw error
    }
  }

  const addUsers = async (id) => {
    try {
      const REQ_URL = `/api/pdf-signing/v2/docket/${id}/signees`
      const REQ_BODY = {}
      REQ_BODY.signees = users

      const CONFIG = {
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
      }

      await postRequest(REQ_URL, REQ_BODY, CONFIG)
    } catch (error) {
      throw error
    }
  }

  const validateAllEntries = (role) => {
    try {
      let filteredUsers = users.filter((user) => user.role == role) || []
      let userCount = filteredUsers.length
      if (userCount != 0) {
        for (let i = 0; i < userCount; i++) {
          let entry = filteredUsers[i]
          try {
            if (!entry.email.trim()) throw `${role} ${i + 1} email shouldn't be empty.`
            if (!EMAIL_REGEX.test(entry.email)) throw `Kindly provide valid email address for ${role} ${i + 1}.`
            if (!entry.hasOwnProperty("internal")) throw `Kindly check / submit email address to fetch details ${role} ${i + 1}`
            if (!entry.name.trim()) throw `${role} ${i + 1} name shouldn't be empty.`

            if (role == "SIGNER") if (!Boolean(entry.placements.length)) throw `Kindly add atleast one signature placement for Signer named as <strong>${entry.name}</strong>`

            entry.error = false
          } catch (error) {
            entry.error = true
            // console.log({ users })
            throw error
          }
        }
      }

      if (userCount > 1) validateDuplicates(role)
    } catch (error) {
      throw error
    } finally {
      users = [...users]
    }
  }

  const checkOverlaps = (signers) => {
    const placements = []

    // Collect all placements with a signature
    for (const signer of signers) {
      if (signer.sign) {
        signer.placements = signer.placements.map((placement) => {
          placement.error = false
          return placement
        })
        placements.push(...signer.placements)
      }
    }

    let isOverlapped = false

    // console.log(placements)

    // Compare each placement with every other
    for (let i = 0; i < placements.length; i++) {
      for (let j = i + 1; j < placements.length; j++) {
        if (!shouldCompare(placements[i].pages, placements[j].pages)) continue

        if (isOverlapping(placements[i].coordinate, placements[j].coordinate)) {
          // Set error to true when overlap is found
          if (!placements[i].error) placements[i].error = true
          if (!placements[j].error) placements[j].error = true

          // placements[i].error = placements[j].error = true

          // console.log(placements[i].id, placements[j].id)

          isOverlapped = true
        }
      }
    }

    return { updatedUsers: signers, isOverlapped }
  }

  const shouldCompare = (pages1, pages2) => {
    if (pages1 === "ALL" || pages2 === "ALL") return true

    const num1 = Number(pages1)
    const num2 = Number(pages2)

    if (pages1 === "EVEN") {
      if (pages2 === "EVEN" || (Number.isInteger(num2) && num2 % 2 !== 0)) return true
    }
    if (pages2 === "EVEN") {
      if (Number.isInteger(num1) && num1 % 2 !== 0) return true
    }

    if (pages1 === "ODD") {
      if (pages2 === "ODD" || (Number.isInteger(num2) && num2 % 2 === 0)) return true
    }
    if (pages2 === "ODD") {
      if (Number.isInteger(num1) && num1 % 2 === 0) return true
    }

    if (Number.isInteger(num1) && Number.isInteger(num2)) return num1 === num2
    return false
  }

  // Function to check if two placements overlap
  const isOverlapping = (coord1, coord2) => {
    const { x1, y1, x2, y2 } = parseCoordinates(coord1)
    const { x1: x3, y1: y3, x2: x4, y2: y4 } = parseCoordinates(coord2)

    // No overlap conditions
    if (x1 >= x4 || x3 >= x2 || y1 >= y4 || y3 >= y2) return false // One is completely to the left/right/above/below the other

    return true // Otherwise, they overlap
  }

  // Function to parse coordinate string
  const parseCoordinates = (coord) => {
    const [x1, y1, x2, y2] = coord.split(",").map(Number)
    return { x1, y1, x2, y2 }
  }

  const handleSubmission = async () => {
    try {
      showLoader = true
      docketName = docketName.trim()

      validateAllEntries("APPROVER")

      let signers = users.filter((user) => user.role == "SIGNER")
      if (!Boolean(signers.length)) throw "Kindly add atleast 1 signer to proceed"
      validateAllEntries("SIGNER")

      const { updatedUsers, isOverlapped } = checkOverlaps(users)

      users = [...updatedUsers]
      if (isOverlapped) throw "Overlapped Placements found."

      // if (pdfHasDifferentSize) {
      //   let isPlacementModified = await validatePlacements()

      //   if (isPlacementModified) {
      //     notify.info("Since the PDF contains pages of varying dimensions, the placement has been adjusted to ensure they remain within the page boundaries. Please review it.")
      //     return
      //   }
      // }

      // updatePlacements()

      // console.log({ users })

      showEmailConfirmationModal = true
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: Validating Docket details before proceeding with email confirmation followed by docket creation"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
    }
  }

  const updatePlacements = () => {
    try {
      users = users.map((user) => {
        user.placements = user.placements.map((placement) => {
          if (placement.coordinate) {
            // Parse the coordinates for the signature
            let [x1, y1, x2, y2] = placement.coordinate.split(",").map(Number)

            x2 = Math.floor(x2)
            y2 = Math.floor(y2)

            placement.coordinate = `${x1}, ${y1}, ${x2}, ${y2}`
          }

          return placement
        })
        return user
      })
    } catch (error) {
      throw error
    }
  }

  const validatePlacements = () => {
    return new Promise((resolve, reject) => {
      try {
        loaderMsg = "Validating Signature Placements"
        let externalMultiPageSigners = users.filter((user) => user.role == "SIGNER" && !user.internal && Array.isArray(user.placements) && user.placements.some((placement) => placement.pages === "ALL" || placement.pages === "ODD" || placement.pages === "EVEN"))

        let isPlacementModified = false

        for (let i = 0; i < externalMultiPageSigners.length; i++) {
          const user = externalMultiPageSigners[i]

          // Filter and log only relevant placements
          const filteredPlacements = user.placements.filter((placement) => placement.pages === "ALL" || placement.pages === "ODD" || placement.pages === "EVEN")

          for (const placement of filteredPlacements) {
            let isPlacementGoesOut = checkOutOfBoundary(pageDimensions, placement.type, placement.coordinate)

            if (isPlacementGoesOut) {
              const modifiedPlacement = modifyPlacement(placement.coordinate, pageDimensions)

              updatePlacement(modifiedPlacement, user.id, placement.id)

              isPlacementModified = true
            }
          }
        }

        resolve(isPlacementModified)
      } catch (error) {
        reject(error)
      } finally {
        loaderMsg = "Fetching Docket Details"
      }
    })
  }

  // const checkMultiPagePlacement = async (placement, userName) => {
  //   try {
  //     for (let i = 0; i < totalPages; i++) {
  //       const pageNumber = i + 1

  //       if ((placement.pages === "ODD" && pageNumber % 2 === 0) || (placement.pages === "EVEN" && pageNumber % 2 !== 0)) continue

  //       const page = await _PDFDOC.getPage(pageNumber)

  //       const { width, height } = page.getViewport({ scale: 1 })

  //       // Parse the coordinates for the signature
  //       let [x1, y1, x2, y2] = placement.coordinate.split(",").map(Number)

  //       console.log(x1, y1, x2, y2)

  //       if (x1 < 0 || y1 < 0 || x2 > width || y2 > height) throw `The placement placed for Signer named as ${userName} doesn't fit well because page ${pageNumber} has a different size.`
  //     }
  //   } catch (error) {
  //     throw error
  //   }
  // }

  const handleAfterEmailConfirmation = async () => {
    try {
      showEmailConfirmationModal = false
      loaderMsg = "Creating Docket Details"
      showLoader = true

      let refId = ""
      let url = ""

      if ($DocDetails.id && $DocDetails.url) {
        refId = $DocDetails.id
        url = $DocDetails.url
      } else {
        if (isPublishEnabled) {
          const apiData = await initDocument()
          refId = apiData.documentID
          url = apiData.proposedURL
        }
      }

      const docketId = await createDocket(refId, files, url)

      arrangePlacements()

      await addUsers(docketId)

      if (refId) await linkDocket(refId, docketId)

      await sendEmail(docketId)

      push(`/signing/single/docket?id=${docketId}`)
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: During Docket creation after email confirmation"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
      loaderMsg = "Fetching Details"
    }
  }

  const arrangePlacements = () => {
    try {
      users = users.map((user) => {
        if (user.role != "APPROVER" && !user.internal && user.placements.length > 1) {
          let defaultPlacement = user.placements.filter((placement) => placement.default) || []
          let otherPlacements = user.placements.filter((placement) => !placement.default) || []

          user.placements = [...defaultPlacement, ...otherPlacements]

          user.placements = user.placements.map((placement) => {
            delete placement.default
            delete placement.error
            return placement
          })
        }
        return user
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  const linkDocket = async (refId, docketId) => {
    try {
      const REQ_URL = `/api/swagger/v2/documents/${refId}/meta`
      const REQ_BODY = {
        docket: docketId,
      }
      const CONFIG = {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }

      await patchRequest(REQ_URL, REQ_BODY, CONFIG)
    } catch (error) {
      throw error
    }
  }

  const sendEmail = async (id) => {
    try {
      const REQ_URL = `/api/pdf-signing/v2/docket/${id}/mail`

      const CONFIG = {
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
      }

      await getRequest(REQ_URL, CONFIG)
    } catch (error) {
      throw error
    }
  }

  /**
   * Queues a page to be rendered if a PDF page is currently being loaded.
   * If no page is being loaded, it immediately renders the specified page.
   *
   * @param {number} pageno - The page number to render.
   */
  const queueRenderPage = () => {
    try {
      // Check if a PDF page is currently being loaded
      if (loadingPDF) {
        // Set the pending page number to the specified page number
        pageNumPending = currentpage || 1
      } else {
        // Render the specified page immediately
        showPage(currentpage || 1)
      }
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: During PDF page navigation"
      closeNotification = notify.danger(error, info)
    }
  }

  const deleteUser = (id) => {
    try {
      users = users.filter((user) => user.id != id)
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: While deleting approver/ signer"
      closeNotification = notify.danger(error, info)
    }
  }

  const handleInternalCheck = async (e) => {
    try {
      isPublishEnabled = e.target.checked

      users = await Promise.all(
        users.map(async (user) => {
          const signDetails = {
            name: user.name,
            role: user.role,
            showQR: isPublishEnabled,
          }
          user.sign = await drawSign(signDetails)
          return user
        })
      )
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: While updating user details based on the choice to publish or not"
      closeNotification = notify.danger(error, info)
    }
  }

  const showSignOverlay = async (needTOShowModel = true) => {
    if (!files) {
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: File validation before proceeding to docket creation"
      closeNotification = notify.danger("Kindly upload file to continue", info)
      return
    }
    if (isPdfDigitallySigned && needTOShowModel) {
      pdfDigitallySignedModal = true
      return
    }
    await showAddSignerSection()
  }

  const showAddSignerSection = async () => {
    try {
      showLoader = true
      addSignerSection = true

      await tick()

      console.log({ pageDimensions })

      let uniqueDimensions = [...new Set(pageDimensions)]

      pdfHasDifferentSize = Boolean(uniqueDimensions.length != 1)

      // console.log({ pdfHasDifferentSize })

      let blobURL = URL.createObjectURL(files)
      await showPDF(blobURL)
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: While preparing document to preview during docket creation"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
    }
  }

  const checkSpecialChars = (e) => {
    const info = "PAGE: Docket Creation\nEVENT: Validating invalid characters for the docket name during onBlur/ onPaste/ onKeypress"

    // Destructure the type and key properties from the event object
    let { type, key } = e

    const ALLOWED_CHARS_REGEX = /^[A-Z\d\s-()+&.]*$/i

    // Check if it's a keypress event and the pressed key is not allowed
    if (type === "keypress" && !ALLOWED_CHARS_REGEX.test(key)) {
      invalidNotification.close()

      // Temporarily append the invalid key
      docketName += key

      // Prevent the default keypress behavior
      e.preventDefault()

      // Show a danger notification
      // notify.danger("Only <strong>Letters</strong>,<strong>Numbers</strong> and <strong>-()+.&</strong> are allowed.", info)
      invalidNotification = notify.danger("Only <strong>Letters</strong>,<strong>Numbers</strong> and <strong>-()+.&</strong> are allowed.", info)

      setTimeout(() => {
        // Remove the last invalid character
        docketName = docketName.slice(0, -1)
      }, 100)
    } else if (type === "paste") {
      e.preventDefault()
      let clipboardData = e.clipboardData || window.clipboardData
      let pastedText = clipboardData.getData("text/plain")

      const input = e.target
      const start = input.selectionStart
      const end = input.selectionEnd

      let updated = docketName.substring(0, start) + pastedText + docketName.substring(end)
      docketName = updated

      setTimeout(() => {
        if (!ALLOWED_CHARS_REGEX.test(pastedText)) {
          let sanitizedText = pastedText.replace(/[^A-Za-z0-9\s-()+&.]/g, "").trim()
          if (sanitizedText !== pastedText) {
            notify.danger("Only <strong>Letters</strong>, <Strong>Numbers</strong> and <br/> <strong>-()+.&</strong> are allowed. Removing non-specified Characters", info)
          }
          docketName = docketName.substring(0, start) + sanitizedText + docketName.substring(end)
        }

        checkMaxCharacters()
      }, 500)
    } else if (type === "blur") {
      docketName = docketName.trim()
      if (!ALLOWED_CHARS_REGEX.test(docketName)) {
        let sanitizedText = docketName.replace(/[^A-Za-z0-9\s-()+&.]/g, "").trim()
        if (sanitizedText !== docketName) {
          notify.danger("Only <strong>Letters</strong>, <Strong>Numbers</strong> and <br/> <strong>-()+.&</strong> are allowed. Removing non-specified Characters", info)
        }
        docketName = sanitizedText
      }
      checkMaxCharacters()
    }
  }

  const checkDocketOrgEmail = () => {
    docketOrgEmail = docketOrgEmail.trim()
    if (!docketOrgEmail) return

    if (!emailAddressPattern.test(docketOrgEmail)) {
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: Validating docket notification email address during onBlur"
      closeNotification = notify.danger("Kindly provide a valid email address for the notification email.", info)
      setTimeout(() => {
        docketOrgEmail = ""
      }, 100)
      return
    }
  }

  const checkMaxCharacters = () => {
    maxNotification.close()

    const MAX_CHARS = 25

    if (docketName && docketName.length >= MAX_CHARS) {
      // Displaying notification for exceeding maximum characters
      maxNotification = notify.info(`Docket name should not be more than ${MAX_CHARS} characters`)

      // Setting a timer to slice the name to maxCharacters
      setTimeout(() => {
        docketName = docketName.slice(0, MAX_CHARS)
      }, 20)
    }
  }

  const handleNavChange = () => {
    try {
      if (action == "Approvers") {
        validateAllEntries("APPROVER")
        action = "Signers"
      } else {
        validateAllEntries("SIGNER")
        action = "Approvers"
      }
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: While changing navs between Approver and Signer"
      closeNotification = notify.danger(error, info)
    }
  }

  const fetchSeals = async (page = 1, limit = 10, sort = "-1", sortBy = "date") => {
    try {
      const data = await getRequest(`/api/pdf-signing/v2/seal?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}`, {
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
      })

      // console.log(data)

      sealCount = data.count
      seals = data.seals || []
      sealEndCount = sealCount < 10 ? sealCount : 10
      sealMaxCount = Math.ceil(sealCount / 10)
    } catch (error) {
      const info = "PAGE: Docket Creation\nEVENT: While fetching Seals to list in dropdown"
      notify.danger(error, info)
    }
  }

  const handleSinglePagePlacementValidation = (currentPlacement) => {
    try {
      showLoader = true
      loaderMsg = "Validating Signature Placement"

      // console.log({ currentPlacement })
      console.log({ pageDimensions })

      // console.log({ previousPage: Number(currentPlacement.prevPage), currentpage: Number(currentpage) - 1 })

      // Previous Page Dimensions
      const [width, height] = pageDimensions[Number(currentPlacement.prevPage)].split("*")
      console.log({ width, height })

      // New Page Dimensions
      const [newWidth, newHeight] = pageDimensions[Number(currentpage) - 1].split("*")

      if (newWidth == width && newHeight == height) return

      // Parse the coordinates of the current signature placement
      let [x1, y1, x2, y2] = currentPlacement.coordinate.split(",").map(Number)

      const aspect = (x2 - x1) / (y2 - y1)
      // console.log({ aspect })

      const leftPosition = x1 / width
      const bottomPosition = y1 / height

      // console.log({ leftPosition, bottomPosition, leftPosition2, bottomPosition2 })

      // console.log(currentpage)

      const modifiedPlacement = {}
      modifiedPlacement.x1 = leftPosition * newWidth
      modifiedPlacement.y1 = bottomPosition * newHeight

      // Maintain aspect ratio: scale using width ratio
      const scaledBoxW = (x2 - x1) * (newWidth / width)
      const scaledBoxH = scaledBoxW / aspect // preserve aspect

      // New x2,y2
      modifiedPlacement.x2 = modifiedPlacement.x1 + scaledBoxW
      modifiedPlacement.y2 = modifiedPlacement.y1 + scaledBoxH

      if (modifiedPlacement.y2 > Number(newHeight)) {
        const modifiedHeight = modifiedPlacement.y2 - modifiedPlacement.y1

        modifiedPlacement.y2 = Number(newHeight)
        modifiedPlacement.y1 = newHeight - modifiedHeight
      }

      if (modifiedPlacement.x2 > Number(newWidth)) {
        const modifiedWidth = modifiedPlacement.x2 - modifiedPlacement.x1

        modifiedPlacement.x2 = Number(newWidth)
        modifiedPlacement.x1 = newWidth - modifiedWidth
      }

      // console.log({ width, height, pdfDimensions })

      console.log({ modifiedPlacement })

      updatePlacement(modifiedPlacement, currentPlacement.user, currentPlacement.id)
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: While validating signature placement during page change as the pdf pages have different dimensions"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
      loaderMsg = "Fetching Details"
    }
  }

  const updatePlacement = (modified, userId, placementId) => {
    try {
      users = users.map((user) => {
        if (user.id == userId) {
          user.placements = user.placements.map((placement) => {
            if (placement.id == placementId) {
              const { x1, y1, x2, y2 } = modified
              placement.coordinate = `${x1}, ${y1}, ${x2}, ${y2}`
            }
            return placement
          })
        }
        return user
      })
    } catch (error) {
      throw error
    }
  }

  const handlePlacementValidation = (e) => {
    try {
      let currentPlacement = e.detail
      showLoader = true
      loaderMsg = "Validating Signature Placements"

      let isPlacementGoesOut = checkOutOfBoundary(pageDimensions, currentPlacement.type, currentPlacement.coordinate)

      if (isPlacementGoesOut) {
        const modifiedPlacement = modifyPlacement(currentPlacement.coordinate, pageDimensions)

        updatePlacement(modifiedPlacement, currentPlacement.user, currentPlacement.id)

        notify.info("Since the PDF contains pages of varying dimensions, the placements have been adjusted to ensure they remain within the page boundaries. Please review it.")
      }
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: While validating signature placement during Multi-page selection as the pdf pages have different dimensions"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false
      loaderMsg = "Fetching Details"
    }
  }

  const handlePageChange = (e) => {
    try {
      const { pageNo, ...placement } = e.detail
      currentpage = pageNo
      // console.log(currentpage, placement)

      console.log(pdfHasDifferentSize)

      if (pdfHasDifferentSize) handleSinglePagePlacementValidation(placement)
      queueRenderPage()
    } catch (error) {
      console.error(error)
    }
  }

  onDestroy(() => {
    $DocDetails = {
      id: "",
      url: "",
      file: "",
    }
  })
</script>

<svelte:head>
  <title>Doc Multi-Signer</title>
</svelte:head>

<svelte:window
  on:beforeunload={(e) => {
    if (addSignerSection || files) e.preventDefault()
  }}
/>

{#if showGoBackModal}
  <Modal
    title="Leave Docket"
    btnName="Confirm"
    on:click={() => {
      showGoBackModal = false
    }}
    on:confirm={() => {
      showGoBackModal = addSignerSection = false
      docketName = ""
      currentpage = 1
      files = null
      users = []

      if ($DocDetails.id && $DocDetails.url) push(`/publish/single/upload_document?documentId=${$DocDetails.id}`)
    }}
  >
    <div class="flex w-3/4 flex-col items-center gap-3 break-words p-3 text-center text-gray-d00 dark:text-gray-200 mobile:p-6">
      <p>Are you sure you want to go back? Any changes made and documents uploaded will be lost.</p>
    </div>
  </Modal>
{/if}

{#if showEmailConfirmationModal}
  <Modal
    title="Email users for approval and signing"
    btnName="Confirm"
    on:click={() => {
      showEmailConfirmationModal = false
    }}
    on:confirm={handleAfterEmailConfirmation}
  >
    <div class="flex w-3/4 flex-col items-center gap-3 break-words p-3 text-center text-gray-d00 dark:text-gray-200 mobile:p-6">
      <p>After creating the docket with a list of approvers and signers, emails will first be sent to the approvers. Once they provide their approval, emails will then be automatically sent to the signers. You also have the option to resend the email after the docket has been created.</p>
    </div>
  </Modal>
{/if}

{#if pdfDigitallySignedModal}
  <Modal
    title="Confirmation"
    btnName="Confirm"
    on:click={() => {
      pdfDigitallySignedModal = false
      isPdfDigitallySigned = false
      files = null
    }}
    on:confirm={async () => {
      pdfDigitallySignedModal = false
      await showAddSignerSection()
    }}
  >
    <div class="w-3/4 break-words p-3 text-center text-gray-d00 dark:text-gray-200 mobile:p-6">
      The document you uploaded is digitally signed. Because of this, <strong class="text-blue-500">users cannot add an e-signature</strong>
      , as doing so would invalidate the existing digital signatures. Additionally, users will not be able to select any preferred signing method.
    </div>
  </Modal>
{/if}

{#if showUserDltModal}
  <Modal
    title="Delete {activeName.split(' ')[0]}"
    btnName="Confirm"
    on:click={() => {
      showUserDltModal = false
    }}
    on:confirm={() => {
      deleteUser(activeId)
      showUserDltModal = false
    }}
  >
    <div class="w-3/4 break-words p-3 text-center text-gray-d00 dark:text-gray-200 mobile:p-6">
      Do you want to delete <strong class="text-black dark:text-white">{activeName}</strong>
      ?
    </div>
  </Modal>
{/if}

{#if showLoader}
  <Loader loadingMsg={loaderMsg} />
{/if}

{#if !addSignerSection}
  <div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
    <Navbar />
    <div class="">
      <div class="mx-auto h-auto w-full max-w-[920px] px-6 pb-40 pt-6">
        <Header headerName="Upload Document" redirectUrl="/signing/multiSigner" />

        <div class="flex min-h-[470px] flex-col items-center justify-between gap-6 rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
          {#if !files}
            <div class="w-4/5">
              <Uploadfile on:change={checkFileUpload} supportedFormats={"PDF and DOCX"} />
            </div>
          {:else}
            <PdfPreview bind:pageDimensions on:click={() => (files = null)} uri={URL.createObjectURL(files)} />
          {/if}

          <div class="ml-auto">
            <Button on:click={showSignOverlay} btnName="Confirm" leftIcon="check" btnclr="blue" />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
{/if}

{#if addSignerSection}
  <div class="fixed inset-0 z-10 flex h-screen w-screen bg-[#f7f7f7] dark:bg-bodyblack">
    <div class="flex h-full w-full">
      <div class="h-full w-full space-y-3 p-3">
        <div class="flex items-center gap-6">
          <button
            on:click={() => {
              showGoBackModal = true
            }}
            class="flex items-center gap-2 whitespace-nowrap font-bold text-gray-d00 hover:text-blue-500 dark:text-white"
          >
            <i class="fa-solid fa-backward" />
            <span>Back</span>
          </button>

          <!-- Docket input -->
          <div class="group relative flex w-1/4 min-w-[300px] rounded-md">
            <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">NAME</div>
            <input
              on:blur={() => {
                docketName = docketName.trim()
              }}
              on:blur={checkSpecialChars}
              on:paste={checkSpecialChars}
              on:keypress={checkSpecialChars}
              on:keypress={checkMaxCharacters}
              bind:value={docketName}
              type="text"
              placeholder="Enter Docket name (Optional)"
              class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-black outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:text-white"
            />
          </div>
          <div class="flex items-center gap-1.5">
            <div class="group relative flex w-1/4 min-w-[300px] rounded-md">
              <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">EMAIL</div>
              <input on:blur={checkDocketOrgEmail} bind:value={docketOrgEmail} type="text" placeholder="Enter notification email (Optional)" class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-black outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:text-white" />
            </div>
            <div data-tooltip="This email will be used to send docket-related updates, including signing status and issue notifications." tooltip-position="bottom" class="forder flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-stone-700 text-yellow-500 hover:text-yellow-400">
              <i class="fa-solid fa-info" />
            </div>
          </div>
        </div>
        <div class="flex h-full w-full flex-col items-center justify-center pb-10">
          <div class="flex w-1/2 flex-col items-center justify-center md:w-3/5 lg:w-[70%] xl:w-[73%]">
            <div style="max-width: {window.innerWidth / 2}px;max-height:{window.innerHeight - 120}px" class="flex h-full w-full flex-col items-center gap-3 overflow-hidden rounded-md">
              <SignOverlay {pdfDimensions} {users} {currentpage} {loadingPDF}>
                <canvas bind:this={canvas} class="h-full w-full rounded-md border border-gray-300" />
              </SignOverlay>
            </div>

            <div class="{!loadingPDF ? 'opacity-100' : ' opacity-0'} mt-3 flex w-full items-center justify-center gap-3 pb-3">
              <PageControl bind:currentpage on:render={queueRenderPage} {totalPages} />
            </div>
          </div>
        </div>
      </div>

      <div class="flex w-1/2 min-w-[400px] flex-col justify-between bg-white p-3 text-gray-600 dark:bg-lightgray md:w-2/5 lg:w-[30%] xl:w-[27%]">
        <div class="flex flex-col overflow-auto">
          <!-- TABS -->
          <div class="z-10 mb-[-2px] flex gap-3">
            <button disabled={action == "Approvers"} type="button" on:click={handleNavChange} class="group min-h-[36px] gap-3 whitespace-nowrap rounded-t-md border-2 border-b-0 text-base font-bold {action == 'Approvers' ? ' border-gray-100 bg-white text-yellow-500 dark:border-stone-700 dark:bg-lightgray' : 'border-transparent bg-gray-100 hover:bg-yellow-500 dark:bg-bodyblack hover:dark:bg-yellow-500'} ">
              <div class="flex w-full items-center gap-2 border-l-4 px-3 {action == 'Approvers' ? 'border-yellow-500' : 'border-[#f7f7f7] text-[#f7f7f7] group-hover:border-white group-hover:text-white dark:border-gray-200 dark:text-gray-200 group-hover:dark:border-white group-hover:dark:text-white'}">
                <i class="fa-solid fa-file-signature" />
                Approvers
              </div>
            </button>
            <button disabled={action == "Signers"} type="button" on:click={handleNavChange} class="group min-h-[36px] gap-3 whitespace-nowrap rounded-t-md border-2 border-b-0 text-base font-bold {action == 'Signers' ? ' border-gray-100 bg-white text-green-500 dark:border-stone-700 dark:bg-lightgray' : 'border-transparent bg-gray-100 hover:bg-green-500 dark:bg-bodyblack hover:dark:bg-green-500'} ">
              <div class="flex w-full items-center gap-2 border-l-4 px-3 {action == 'Signers' ? 'border-green-500' : 'border-[#f7f7f7] text-[#f7f7f7] group-hover:border-white group-hover:text-white dark:border-gray-200 dark:text-gray-200 group-hover:dark:border-white group-hover:dark:text-white'}">
                <i class="fa-solid fa-signature" />
                Signers
              </div>
            </button>
            <!-- {#each ["Approvers", "Signers"] as tab}
              <button disabled={action == tab} type="button" on:click={handleNavChange} class="min-h-[36px] w-full gap-3 rounded-t-md pl-3 {action == 'Approvers' ? 'bg-transparent text-yellow-500' : action == 'Signers' ? 'bg-transparent text-green-500' : 'bg-transparent text-white'} whitespace-nowrap text-base font-bold">
                <i class="fa-solid {tab == 'Approvers' ? 'fa-file-signature' : 'fa-signature'}" />
                {tab}
              </button>
            {/each} -->
          </div>
          <div class="flex flex-col overflow-auto rounded-b-md rounded-tr-md border-2 border-gray-100 p-3 dark:border-stone-700">
            {#if action == "Approvers"}
              <Button
                on:click={() => {
                  addUser("APPROVER")
                }}
                size="full"
                leftIcon="circle-plus"
                btnName="Add Approver"
                btnclr="green"
              />
              <form name="approverForm" class="flex w-full flex-col gap-3 overflow-x-hidden overflow-y-scroll pr-1 {users.filter((user) => user.role == 'APPROVER').length ? 'mt-3' : ''}">
                <!-- ADD APPROVER -->
                {#each users.filter((user) => user.role == "APPROVER") as user, i (user.id)}
                  <Approver
                    {isPdfDigitallySigned}
                    bind:user
                    index={i}
                    {currentpage}
                    {totalPages}
                    {sealCount}
                    {seals}
                    {sealEndCount}
                    {sealMaxCount}
                    {isPublishEnabled}
                    approvers={users.filter((user) => user.role == "APPROVER")}
                    on:active={() => {
                      let active = user.id
                      users = users.map((user) => {
                        if (user.role == "APPROVER" && active != user.id) user.active = false
                        return user
                      })
                    }}
                    on:pageChange={handlePageChange}
                    on:click={() => {
                      activeId = user.id
                      user.name = user.name.trim()
                      activeName = user.name ? `Approver named as ${user.name}` : `Approver ${i + 1}`
                      showUserDltModal = true
                    }}
                  />
                {/each}
              </form>
            {/if}
            {#if action == "Signers"}
              <Button on:click={() => addUser("SIGNER")} size={"full"} leftIcon={"circle-plus"} btnName={"Add Signer"} btnclr={"green"} />

              <form name="signerForm" class="flex w-full flex-col gap-3 overflow-x-hidden overflow-y-scroll pr-1 {users.filter((user) => user.role == 'SIGNER').length ? 'mt-3' : ''}">
                {#each users.filter((user) => user.role == "SIGNER") as user, i (user.id)}
                  <SignerList
                    {totalPages}
                    signers={users.filter((user) => user.role == "SIGNER")}
                    {currentpage}
                    {sealCount}
                    {seals}
                    {sealEndCount}
                    {sealMaxCount}
                    {isPublishEnabled}
                    {pdfHasDifferentSize}
                    bind:user
                    index={i}
                    on:pageChange={handlePageChange}
                    on:pdfCheck={handlePlacementValidation}
                    on:active={() => {
                      let active = user.id
                      users = users.map((user) => {
                        if (user.role == "SIGNER" && active != user.id) user.active = false
                        return user
                      })
                    }}
                    on:click={() => {
                      activeId = user.id
                      user.name = user.name.trim()
                      activeName = user.name ? `Signer named as ${user.name}` : `Signer ${i + 1}`
                      showUserDltModal = true
                    }}
                  />
                {/each}
              </form>
            {/if}
          </div>
        </div>

        <div class="space-y-3 pt-3">
          {#if !$DocDetails.id || !$DocDetails.url}
            <div class="flex items-center gap-3">
              <input id="publishPDF" on:change={handleInternalCheck} type="checkbox" checked={isPublishEnabled} class="h-4 w-4 rounded-md disabled:cursor-not-allowed" />
              <label for="publishPDF" class="cursor-pointer select-none text-base font-medium text-slate-500">I opt to publish the document.</label>
            </div>
          {/if}
          <Button on:click={handleSubmission} size={"fit"} btnName={"Confirm and Proceed"} btnclr={"blue"} leftIcon={"check"} />
        </div>
      </div>
    </div>
  </div>
{/if}
